<script lang="ts" setup>
import { NeonBannerService, type NeonMode, NeonModeUtils } from '@art-basel/artbasel-lib-neon';
import { onMounted, onUnmounted } from 'vue';
import { env } from '@/constants';
import { appMessages } from '@/App.messages';
import { getApplicationService } from '@art-basel/artbasel-lib-platform';

const onNewVersion = (_newVersion: string) => {
  NeonBannerService.info({
    key: 'version-banner',
    message: appMessages.refreshBannerTitle,
    action: {
      label: appMessages.refreshButtonLabel,
      callback: () => {
        window.location.reload();
      },
    },
  });
};

onMounted(async () => {
  const mode = localStorage.getItem('mode') as NeonMode;
  NeonModeUtils.init(mode);
  getApplicationService().initVersionCheck(env.VITE_PACKAGE_VERSION, onNewVersion);
});

onUnmounted(() => {
  getApplicationService().destroyVersionCheck();
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition
      mode="out-in"
      name="neon-fade-transition"
    >
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style lang="scss">
@use './global';
</style>
